"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M8 21c.55 0 1-.45 1-1v-5.09c0-.98-.71-1.8-1.67-1.97C5.44 12.63 4 10.98 4 9c0-2.21 1.79-4 4-4 1.98 0 3.63 1.44 3.94 3.33.17.96.99 1.67 1.97 1.67h4.26l-.88.88c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l2.59-2.59c.39-.39.39-1.02 0-1.41L18.7 5.7a.996.996 0 0 0-1.41 0c-.39.39-.39 1.02 0 1.41l.88.89h-4.25C13.44 5.16 10.97 3 8 3 4.69 3 2 5.69 2 9c0 2.97 2.16 5.44 5 5.92V20c0 .55.45 1 1 1"
}), 'RoundaboutRightRounded');